module.exports = __webpack_public_path__ + "static/media/merc_big_l_blur.027fd27a.jpg";